import {
  AlertsAndFollowUpQuestion,
  InterviewAnalysisResult,
  ResumeAnalysisResult
} from '@/types/AnalysisResult';
import { JobRequirements } from '@/types/Job';
import { JobDescription } from '@/types/JobDescription';
import { AdminExtractVeteransResumeResponse } from '@/api/services';
import { create } from 'zustand';

interface AdminAnalysis {
  jdFile: File | null;
  jobDescription: JobDescription | null;
  jobPositionTags: string[] | null;
  resumeFile: File | null;
  resume: Resume | null;
  veteransResume: AdminExtractVeteransResumeResponse | null;
  questionBankFile: File | null;
  questionBank: QuestionBankExtractionData | null;
  jobRequirements: JobRequirements | null;
  resumeAnalysisResult: ResumeAnalysisResult | null;
  interviewAnalysisResult: InterviewAnalysisResult | null;
  followUpQuestions: AlertsAndFollowUpQuestion[] | null;

  setJDFile: (jdFile: File) => void;
  clearJDFile: () => void;
  setJobDescription: (jobDescription: JobDescription) => void;
  setJobPositionTags: (jobPositionTags: string[]) => void;
  clearJobDescription: () => void;
  setResumeFile: (resumeFile: File) => void;
  clearResumeFile: () => void;
  setResume: (resume: Resume) => void;
  clearResume: () => void;
  setVeteransResume: (veteransResume: AdminExtractVeteransResumeResponse) => void;
  clearVeteransResume: () => void;
  setJobRequirements: (jobRequirements: JobRequirements) => void;
  clearJobRequirements: () => void;
  setResumeAnalysisResult: (resumeAnalysisResult: ResumeAnalysisResult) => void;
  clearResumeAnalysisResult: () => void;
  setInterviewAnalysisResult: (interviewAnalysisResult: InterviewAnalysisResult) => void;
  clearInterviewAnalysisResult: () => void;
  setFollowUpQuestions: (followUpQuestions: AlertsAndFollowUpQuestion[]) => void;
  clearFollowUpQuestions: () => void;
  setQuestionBankFile: (questionBankFile: File) => void;
  clearQuestionBankFile: () => void;
  setQuestionBank: (questionBank: QuestionBankExtractionData) => void;
  clearQuestionBank: () => void;
  clearAll: () => void;
}

export const useAdminAnalysis = create<AdminAnalysis>((set) => ({
  jdFile: null,
  jobDescription: null,
  jobPositionTags: null,
  resumeFile: null,
  resume: null,
  veteransResume: null,
  jobRequirements: null,
  resumeAnalysisResult: null,
  interviewAnalysisResult: null,
  followUpQuestions: null,
  questionBankFile: null,
  questionBank: null,

  setJDFile: (jdFile) => set({ jdFile }),
  clearJDFile: () => set({ jdFile: null }),
  setJobDescription: (jobDescription) => set({ jobDescription }),
  setJobPositionTags: (jobPositionTags) => set({ jobPositionTags }),
  clearJobDescription: () => set({ jobDescription: null }),
  setResumeFile: (resumeFile) => set({ resumeFile }),
  clearResumeFile: () => set({ resumeFile: null }),
  setResume: (resume) => set({ resume }),
  clearResume: () => set({ resume: null }),
  setVeteransResume: (veteransResume) => set({ veteransResume }),
  clearVeteransResume: () => set({ veteransResume: null }),
  setJobRequirements: (jobRequirements) => set({ jobRequirements }),
  clearJobRequirements: () => set({ jobRequirements: null }),
  setResumeAnalysisResult: (resumeAnalysisResult) => set({ resumeAnalysisResult }),
  clearResumeAnalysisResult: () => set({ resumeAnalysisResult: null }),
  setInterviewAnalysisResult: (interviewAnalysisResult) => set({ interviewAnalysisResult }),
  clearInterviewAnalysisResult: () => set({ interviewAnalysisResult: null }),
  setFollowUpQuestions: (followUpQuestions) => set({ followUpQuestions }),
  clearFollowUpQuestions: () => set({ followUpQuestions: null }),
  setQuestionBankFile: (questionBankFile) => set({ questionBankFile }),
  clearQuestionBankFile: () => set({ questionBankFile: null }),
  setQuestionBank: (questionBank) => set({ questionBank }),
  clearQuestionBank: () => set({ questionBank: null }),
  clearAll: () =>
    set({
      jobDescription: null,
      resume: null,
      jobRequirements: null,
      resumeAnalysisResult: null,
      interviewAnalysisResult: null,
      followUpQuestions: null,
      jdFile: null,
      resumeFile: null,
      questionBankFile: null,
      questionBank: null
    })
}));
